// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import * as msal from "@azure/msal-browser";

/**
 * This component is loaded to grant consent for graph permissions.
 */
class ConsentPopup extends React.Component {
  componentDidMount() {
    microsoftTeams.app.initialize().then(() => {
      // Get the tab context, and use the information to navigate to Azure AD login page
      microsoftTeams.app.getContext().then(async (context) => {
        // const scope = "https://graph.microsoft.com/.default";
        const scope =
          "User.Read profile openid email Mail.Send Sites.ReadWrite.All";
        const loginHint = context.user!.loginHint;

        let clientId = process.env.REACT_APP_MSAL_APP_ID;
        if (!clientId) {
          clientId = "";
          console.error("MSAL_APP_ID is not set.");
        }

        const msalConfig: msal.Configuration = {
          auth: {
            clientId,
            authority: `https://login.microsoftonline.com/${
              context.user!.tenant!.id
            }`,
            navigateToLoginRequestUrl: false,
          },
          cache: {
            cacheLocation: "sessionStorage",
          },
        };

        const msalInstance = new msal.PublicClientApplication(msalConfig);

        const scopesArray = scope.split(" ");
        const scopesRequest = {
          scopes: scopesArray,
          redirectUri: window.location.origin + `/login-m365-auth-end`,
          loginHint: loginHint,
          prompt: "consent",
        };

        await msalInstance.loginRedirect(scopesRequest);
      });
    });
  }

  render() {
    return (
      <div>
        <p>Loading...</p>
      </div>
    );
  }
}

export default ConsentPopup;
